var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseButtonPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 70",
    fill: "#321700",
    stroke: "#C08D55",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#closeButtonPolygon_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 1l25.98 15v30L31 61 5.02 46V16L31 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 1l25.98 15v30L31 61 5.02 46V16L31 1z",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "closeButtonPolygon_svg__filter0_d",
    x: 0.269,
    y: 0.134,
    width: 61.462,
    height: 69.732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjIgNzAiIGZpbGw9IiMzMjE3MDAiIHN0cm9rZT0iI0MwOEQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9kKSI+CiAgICA8cGF0aCBkPSJNMzEgMUw1Ni45ODA4IDE2VjQ2TDMxIDYxTDUuMDE5MjQgNDZWMTZMMzEgMVoiIGZpbGw9IiMzMjE3MDAiLz4KICAgIDxwYXRoIGQ9Ik0zMSAxTDU2Ljk4MDggMTZWNDZMMzEgNjFMNS4wMTkyNCA0NlYxNkwzMSAxWiIgc3Ryb2tlPSIjQzA4RDU1IiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDwvZz4KPGRlZnM+CiAgPGZpbHRlciBpZD0iZmlsdGVyMF9kIiB4PSIwLjI2OTI4NyIgeT0iMC4xMzM3ODkiIHdpZHRoPSI2MS40NjE1IiBoZWlnaHQ9IjY5LjczMiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgogICAgPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KICAgIDxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIi8+CiAgICA8ZmVPZmZzZXQgZHk9IjQiLz4KICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjIiLz4KICAgIDxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjI1IDAiLz4KICAgIDxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Ii8+CiAgICA8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPgogIDwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgCloseButtonPolygon as ReactComponent };